<h2 mat-dialog-title>{{ params.title }}</h2>

<mat-dialog-content>
  <lib-generic-table
    [dataSource]="params.dataSource"
    [columns]="params.columns"
    [selectionMode]="params.selectionMode ?? 'single'"
    [identityFn]="params.identityFn"
    [defaultSort]="params.defaultSort ?? ''"
    [defaultSortDirection]="params.defaultSortDirection ?? 'asc'"
    [pageSize]="params.pageSize ?? 20"
    [rowClickable]="true"
    [stickyHeader]="true"
    (selectionChanged)="onSelectionChanged($event)"
    (rowDoubleClicked)="onRowDoubleClicked($event)"
  />

</mat-dialog-content>

@if (params.selectionMode === 'multi') {
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-stroked-button
            color="primary"
            [disabled]="confirmDisabled"
            (click)="onConfirm()">
      {{ params.confirmLabel ?? 'Select' }}
    </button>
  </mat-dialog-actions>
}
